import { IApplicationState, TCardId } from '../../../../../../../../types/types';
import { getCardDueDate } from '../../../../../../../../store/model/selectors/getCardDueDate';
import { getCardSubcards } from '../../../../../../../../store/model/selectors/getCardSubcards';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';

export const getCardSubcardIdWithMaxDate = (
    state: IApplicationState,
    cardId: TCardId,
): number => {
    const card = getCard(state, cardId);
    if (!card) return null;

    const subcards = getCardSubcards(state, cardId);

    let subcardMax = 0;
    let subcardIdWithMaxDate = 0;
    subcards.forEach(card => {
        const dueDate = getCardDueDate(state, card.id);
        if (dueDate > subcardMax) {
            subcardMax = dueDate;
            subcardIdWithMaxDate = card.id
        }
    });
    return subcardIdWithMaxDate;
}
